import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Tag,
  TableContainer,
  TagLabel,
  Button,
} from "@chakra-ui/react";

const ScreeningTable = ({ DowJonesIcon }) => {
  const screenings = [
    { entity: "John Doe", riskLevel: "High", type: "PEP", fund: "Apollo Properties" },
    {
      entity: "Jane Smith",
      riskLevel: "Medium",
      type: "Financial Crime",
      fund: "Apollo Properties"
    },
    {
      entity: "Entity D",
      riskLevel: "High",
      type: "Escalated Risk",
      fund: "Horizon Debt"
    },
    {
      entity: "Company Z",
      riskLevel: "High",
      type: "Screening Overdue",
      fund: "Orion Capital"
    },
    {
      entity: "Entity K",
      riskLevel: "High",
      type: "Escalated PEP",
      fund: "Summit Ventures"
    },
    {
      entity: "Individual L",
      riskLevel: "Medium",
      type: "Screening Overdue",
      fund: "Solstice Strategies"
    },
    {
      entity: "Individual M",
      riskLevel: "High",
      type: "High-Risk Alert",
      fund: "Titan Real Estate"
    },
  ];

  return (
    <TableContainer>
      <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>Entity</Th>
            <Th>Fund</Th>
            <Th>Risk Level</Th>
            <Th>Type</Th>
            <Th>Source</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {screenings.map((screening, index) => (
            <Tr key={index}>
              <Td fontWeight={"500"}>{screening.entity}</Td>
              <Td>
                <Tag colorScheme="brand">{screening.fund}</Tag>
              </Td>
              <Td>
                <Badge
                  colorScheme={
                    screening.riskLevel === "High"
                      ? "error"
                      : screening.riskLevel === "Medium"
                      ? "warning"
                      : "success"
                  }>
                  {screening.riskLevel}
                </Badge>
              </Td>
              <Td>
                <Tag colorScheme="grey" size={"sm"}>
                  {screening.type}
                </Tag>
              </Td>
              <Td>
                <Tag gap={2} size={"sm"}>
                  <DowJonesIcon />
                  <TagLabel>Dow Jones</TagLabel>
                </Tag>
              </Td>
            <Td>
              <Button size={"xs"} variant={"outline"}>Screen now</Button>
            </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
export default ScreeningTable;
